const currentUrl = window.location.href;
const hasParams = currentUrl.indexOf('?') !== -1;
if (!currentUrl.includes('view=login')) {
    if(!currentUrl.includes('application-form')) {
        if (hasParams) {
        window.location.href = '/' + '&view=login';
        } else {
            window.location.href = '/' + '?view=login';
        }
    }
}